import { Row, Col, Card, Table, Tabs, Select, Tooltip, Button } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import apiPath from "../../../constants/apiPath";
import moment from "moment";  
import TabPane from "antd/lib/tabs/TabPane";
import { AppStateContext } from "../../../context/AppContext";
import WeeklyChartSection from "./Graph";

function ViewProgress() {
  const heading = "User Challenges";
  const location = useLocation();
  const challengeData = location.state.data;
  const [selectedTab, setSelectedTab] = useState(challengeData?.challenger?._id);
  const { setPageHeading } = useContext(AppStateContext);
  const params = useParams();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState();
  const [refresh, setRefresh] = useState(false);
  const [challengeHistory, setChallengeHistory] = useState([]);
  const [challengeJrHistory, setChallengeJrHistory] = useState([]);
  const navigate = useNavigate();


 const columns = [
    {
      title: "Day",
      dataIndex: "day",
      key: "day",
      width: 200,
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { day }) => {
        return day || "1";
      },
    },
    {
      title: "Checked-In",
      dataIndex: "checked_in",
      key: "checked_in",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { checked_in }) => {
        return !!checked_in ? "CheckedIn" : "Missed";
      },
    },
    {
      title: "Emoji",
      dataIndex: "emoji",
      key: "emoji",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { emoji }) => {
        return emoji ? emoji : "-";
      },
    },
    {
      title: "Checked-In At",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
  ];

  const handleTabChange = (key) => {
    setSelectedTab(key);
  };

  const getChallengeHistory = (id, user) => {
    setLoading(true);
    request({
      url: apiPath.getUserChallengeHistory + `/${id}` + `?user_id=${user}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        if (data?.statusText == "true") {
          setChallengeHistory(data?.data?.list);
        } else {
          ShowToast(data?.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        // ShowToast(err?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const getChallengeJourneyHistory = (id, user) => {
    setLoading(true);
    request({
      url: apiPath.getUserChallengeJRHistory + `/${id}` + `/${user}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        if (data?.statusText == "true") {
          setChallengeJrHistory(data?.data);
        } else {
          ShowToast(data?.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        // ShowToast(err?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    if(!params.id && !selectedTab) return;
    getChallengeJourneyHistory(params.id, selectedTab)
    getChallengeHistory(params.id, selectedTab);
  }, [params.id,refresh,selectedTab]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  return (
    <>
    <Card className="mt-3">
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs={24} xl={24}>
              <Tabs
                className="main_tabs"
                onTabClick={handleTabChange}
                activeKey={selectedTab}
                tabBarStyle={{ color: "green" }}
              >
                <TabPane
                  className="tab-btn"
                  tab="Challenger"
                  key={challengeData?.challenger?._id}
                >
                  <Card className="mt-3">
                    <div className="view-main-list">
                      <div class="view-inner-cls">
                        <h5>Challenge:</h5>
                        <h6>
                          <span class="cap">{challengeData?.challenger_challenge?.challenge_id?.title}</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Name:</h5>
                        <h6>
                          <span class="cap">{challengeData?.challenger?.name}</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Current Day:</h5>
                        <h6>
                          <span class="cap">{challengeHistory?.length || 0}</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total CheckIns:</h5>
                        <h6>
                          <span class="cap">{challengeJrHistory?.checkedInCount || 0}</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total Skips:</h5>
                        <h6>
                          <span class="cap">{challengeJrHistory?.skippedCount || 0}</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total Emotion Checked-In:</h5>
                        <h6>
                          <span class="cap">{challengeJrHistory?.checkedInEmotionCount || 0}</span>
                        </h6>
                      </div>
                    </div>
                  </Card>
                </TabPane>
                <TabPane
                  className="tab-btn"
                  tab="Partner 1"
                  key={challengeData?.receiver?._id}
                >
                  <Card className="mt-3">
                    <div className="view-main-list">
                      <div class="view-inner-cls">
                        <h5>Challenge:</h5>
                        <h6>
                          <span class="cap">{challengeData?.receiver_challenge?.challenge_id?.title}</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Name:</h5>
                        <h6>
                          <span class="cap">{challengeData?.receiver?.name}</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Current Day:</h5>
                        <h6>
                          <span class="cap">{challengeHistory?.length || 0}</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total CheckIns:</h5>
                        <h6>
                          <span class="cap">{challengeJrHistory?.checkedInCount || 0}</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total Skips:</h5>
                        <h6>
                          <span class="cap">{challengeJrHistory?.skippedCount || 0}</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total Emotion Checked-In:</h5>
                        <h6>
                          <span class="cap">{challengeJrHistory?.checkedInEmotionCount || 0}</span>
                        </h6>
                      </div>
                    </div>
                  </Card>
                </TabPane>
                {/* <TabPane className="tab-btn" key={3} tab="Receiver 3">
                  <Card className="mt-3">
                    <div className="view-main-list">
                      <div class="view-inner-cls">
                        <h5>Name:</h5>
                        <h6>
                          <span class="cap">I Phone 16 Pro</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Name:</h5>
                        <h6>
                          <span class="cap">I Phone 16 Pro</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Name:</h5>
                        <h6>
                          <span class="cap">I Phone 16 Pro</span>
                        </h6>
                      </div>
                    </div>
                  </Card>
                </TabPane> */}
              </Tabs>
            </Col>
          </Row>
        </div>
      </Card>
      <Card
        className="criclebox tablespace mb-24 mt-3"
        title={"User Challenges"}
      >
        <div className="table-responsive customPagination">
          <Table
            className="ant-border-space main-table"
            loading={loading}
            columns={columns}
            dataSource={challengeHistory}
            pagination={true}
          />
        </div>
      </Card>

      <Card className="mt-3">
        <h4>Head 2 Head Comparision</h4>
        <div style={{ padding: "25px" }}>
          <Row gutter={[24, 0]}>
            {/* <WeeklyChartSection borderColor="#1EB564" /> */}
          </Row>
        </div>
      </Card>
    </>
  );
}

export default ViewProgress;
